export function hexToRgb(hex) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, (m, r, g, b) => {
    return r + r + g + g + b + b
  })
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ?
    {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    } :
    null
}

export function isColorLight(hex = '#ffffff') {
  // Convert hex to RGB
  const { r, g, b } = hexToRgb(hex)

  // Calculate relative luminance (per WCAG standards)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  // Return true if the color is light, false if dark
  return luminance > 0.5
}

const LIGHT_FILL_TEXT_COLOUR = '#1A1A1A'
const DARK_FILL_TEXT_COLOUR = '#FFFFFF'

function toHex(colour) {
  if (typeof colour !== 'string') return null
  if (hexToRgb(colour)) return colour
  const match = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/i.exec(colour)
  if (!match) return null
  return `#${match.slice(1, 4).map((channel) => Number(channel).toString(16).padStart(2, '0')).join('')}`
}

export function contrastTextColour(fillColour) {
  const hex = toHex(fillColour)
  if (!hex) return DARK_FILL_TEXT_COLOUR
  return isColorLight(hex) ? LIGHT_FILL_TEXT_COLOUR : DARK_FILL_TEXT_COLOUR
}

export function labelColourOnFill(fillColour, isInkAwarePalette) {
  return isInkAwarePalette ? contrastTextColour(fillColour) : undefined
}
